import { get, post } from '@classic/Foundation/Services/ApiService'

export interface WithdrawableResponse {
  accountNumber: number
  balance: number
  withdrawableBalance: number
  isBankAccountRegistered: boolean
  isCRMAvailable: boolean
  desktopUrl: string
  bankName: string
  bankBranchName: string
  bankBsb: string
  bankAccountNumber: string
  bankAccountName: string
}

export const getWithdrawable = async (): Promise<WithdrawableResponse> => {
  return await get<WithdrawableResponse>({ url: '/api/account/withdrawable' })
}

interface WithdrawRequest {
  amount: number
}

export interface WithdrawResponse {
  isSuccessful: boolean
  withdrawalAmount: number
  accountNumber: number
  balance: number
  transactionNumber: number
  transactionTime: Date
}

export const postWithdraw = async (amount: number): Promise<WithdrawResponse> => {
  const request: WithdrawRequest = {
    amount: amount,
  }

  return await post<WithdrawResponse>({
    url: '/api/account/withdraw',
    body: request,
  })
}
